import request from '../../utils/request'

const preFix = '/system/shop';

export const reqListShop = (data) => {
    return request({
        url: preFix + '/list',
        method: 'get',
        params: data
    })
}
export const reqInsertShop = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateShop = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteShopById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetShopById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
